import { Button } from "antd";
import { Palette } from "config/palette";
import styled, { css } from "styled-components";

const buttonStyle = css`
    &.aevi-button {
        height: 30px;
        font-family: "AeviFont", sans-serif;
        font-size: 11pt;
        font-weight: bold;
        border-radius: 4pt;
        border: 1pt solid;
    }

    &.aevi-button-primary {
        color: white;
        background-color: ${Palette.HeroGreen};
        border-color: ${Palette.HeroGreen};
    }

    &.aevi-button-secondary {
        color: ${Palette.HeroGreen};
        background-color: white;
        border-color: ${Palette.HeroGreen};
    }

    &.aevi-button-danger {
        color: ${Palette.AeviRed};
        background-color: white;
        border-color: ${Palette.AeviRed};
    }

    &.aevi-button-black {
        color: ${Palette.AeviBlack};
        background-color: white;
        border-color: ${Palette.AeviBlack};
    }
`;

const buttonStyleDisabled = css`
    &.aevi-button {
        color: ${Palette.DisabledColor};
        background-color: ${Palette.DisabledBackground};
        cursor: not-allowed;
        border-color: ${Palette.DisabledColor};
    }
`;

const antButtonStyleDisabled = css`
    &:hover {
        border-color: ${Palette.DisabledColor} !important;
        color: ${Palette.DisabledColor} !important;
    }
`;

const antButtonStyleCommon = css`
    // Ant specific styles override
    box-shadow: none !important;
    padding: 0 10pt;
    margin: 0;
    // Add styling for button in hover state (override primary default blue)
    &:hover {
        border-color: ${Palette.Highlight} !important;
        color: ${Palette.Highlight} !important;
    }
`;

export const ActionButtonHtmlStyle = styled.button`
    // Vanilla style provides a decoupled styles from the styling library in use.
    ${buttonStyle};
`;

export const ActionButtonStyle = styled(Button)`
    // Vanilla styles injection
    ${(props) => {
        if (props.disabled === true) {
            return css`
                ${buttonStyle};
                ${buttonStyleDisabled};
                ${antButtonStyleCommon}
                ${antButtonStyleDisabled}
            `;
        }
        return css`
            ${buttonStyle};
            ${antButtonStyleCommon};
        `;
    }}}
`;
